module.exports = __webpack_public_path__ + "static/media/md-contacts.2146769b.svg";